import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QContentActivityLogList } from '@exam-management/qcontent-activity-log-list';
import { useParams } from '@exam-management/router';
import { Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ItemSetSubQuestionActivityLogPage() {
  const { subQuestionId } = useParams(
    '/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId/activity-log',
  );

  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.QBANK.QUESTION.VIEW,
        APP_PERMISSIONS.QBANK.AUDIT_LOG.VIEW,
      ]}
    >
      <Box sx={{ p: (theme) => theme.spacing(6) }}>
        <QContentActivityLogList questionId={subQuestionId} />
      </Box>
    </PermissionGuard>
  );
}
